import mock from '../mock'

// ** Third Party Components
import axios from 'axios'

// ** Utils
import { paginateArray } from '../utils'

// ** Utils
import { getUserData } from '@utils'

// ** Custom Components
import GetApiCOC from '../../@fake-db/ApiCOC'

const base64ToString = (response) => { 

  if (response.data.Result === "true" && response.data.response_data.length > 0) {
    return JSON.parse(Buffer.from(response.data.response_data, "base64").toString()) 
  } else {
    return []
  }
}

const getUptakes = async (dataOrigen, refrescar, api, token, body, config) => {

  const configws = {
    method: 'get',
    url:    api,
    headers: { 
      Accept:      'application/json',
      obrientoken: token
    },
    params: body
  }

  let data = dataOrigen

  if (data.uptakes.length <= 0 || data.startDate !== config.startDate || data.endDate !== config.endDate || refrescar) {
    const response = await axios(configws)
    
    if (response.data.Result === 'false') {
      data = { uptakes: base64ToString(response) }
    } else {
      data = { uptakes: base64ToString(response).data }
    }
  }

  // eslint-disable-next-line object-curly-newline
  const { q = '', perPage = 10, page = 1, sort, sortColumn } = config
  /* eslint-enable */

  const dataAsc = data.uptakes.sort((a, b) => {
    const aS = a[sortColumn] ?? ''
    const bS = b[sortColumn] ?? ''

    if (true) {
      return aS < bS ? -1 : 1
    } else {
      const splitColumn = sortColumn.split('.')
      const columnA = a[splitColumn[0]][splitColumn[1]]
      const columnB = b[splitColumn[0]][splitColumn[1]]
      return columnA < columnB ? -1 : 1
    }
  })

  const dataToFilter = sort === 'asc' ? dataAsc : dataAsc.reverse()

  const queryLowered = q.toLowerCase()
  const filteredData = dataToFilter.filter(uptake => {
      return (
          uptake.date.includes(queryLowered) ||
          (uptake.uptake_user ? uptake.uptake_user.includes(queryLowered) : false) ||
          uptake.client_data.name.includes(queryLowered) ||
          (uptake.client_data.email ? uptake.client_data.email.toLowerCase().includes(queryLowered) : false) ||
          (uptake.client_data.phone ? uptake.client_data.phone.toLowerCase().includes(queryLowered) : false) ||
          uptake.property_data.internal_key.toLowerCase().includes(queryLowered) ||
          uptake.property_data.address.toLowerCase().includes(queryLowered)
      )
  })

  return [
    200,
    {
      allData: data.uptakes,
      total: filteredData.length,
      uptakes: filteredData.length <= perPage ? filteredData : paginateArray(filteredData, perPage, page)
    }
  ]  
}

// ------------------------------------------------
// GET: Return list of uptakes
// ------------------------------------------------

let dataUptakes = { uptakes: [], startDate: '', endDate: ''}

mock.onGet('/apps/uptakes').reply(async config => {
  const user = getUserData()

  let user_id2

  if (user.usercoc.role === 2) {
    user_id2  = user.usercoc.user_id
  } else {
    user_id2  = ""
  }

  let refresh = false

  if (config.reset) {
    refresh = true
  }

  if (config.report) {
    refresh = true
    user_id2 = config.user_id
  }

  const body = {
    page            : 1,
    page_size       : '',
    property_filter : '',
    client_filter   : '',
    date_from       : config.startDate,
    date_to         : config.endDate,
    user_id         : user_id2
  }

  const result = await getUptakes(dataUptakes, refresh, GetApiCOC('getUptakes'), user.token, body, config)

  dataUptakes = { uptakes: result[1].allData, startDate: config.startDate, endDate: config.endDate }

  return result
})

